// extracted by mini-css-extract-plugin
export default {"link":"e47b5977","qrCode":"b339b600","teamSelect":"e9b7d7b2"};